// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { CloudInventoryAccountWithRelationsSchema } from './CloudInventoryAccountRelationsSchema'
import type { CloudInventoryAccountWithRelations } from './CloudInventoryAccountRelationsSchema'
import { ExternalNetworkCloudAccountPolicySchema } from './ExternalNetworkCloudAccountPolicySchema';

/////////////////////////////////////////
// EXTERNAL NETWORK CLOUD ACCOUNT POLICY RELATION SCHEMA
/////////////////////////////////////////

export type ExternalNetworkCloudAccountPolicyRelations = {
  surface: ExternalNetworkWithRelations;
  account: CloudInventoryAccountWithRelations;
};

export type ExternalNetworkCloudAccountPolicyWithRelations = z.infer<typeof ExternalNetworkCloudAccountPolicySchema> & ExternalNetworkCloudAccountPolicyRelations

export const ExternalNetworkCloudAccountPolicyWithRelationsSchema: z.ZodType<ExternalNetworkCloudAccountPolicyWithRelations> = ExternalNetworkCloudAccountPolicySchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  account: z.lazy(() => CloudInventoryAccountWithRelationsSchema),
}))